import parseISO from "date-fns/parseISO";
import lightFormat from "date-fns/lightFormat";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import { palette } from "lib/miolo";
import { ArrowUpRight } from "lucide-react";

interface ITotalCompensationsSummaryProps {
  mostRecentRelevantMaterialFact: NonNullable<
    IBrazilianCompanyIssuerTopLevelFragment["mostRecentRelevantMaterialFact"]
  >;
}

export default function MostRecentRelevantIpeSummary({
  mostRecentRelevantMaterialFact,
}: ITotalCompensationsSummaryProps) {
  const deliveryDate = parseISO(mostRecentRelevantMaterialFact.deliveryDate);

  return (
    <a
      href={mostRecentRelevantMaterialFact.url}
      target="_blank"
      rel="noopener noreferrer"
      className="group inline-flex items-center space-x-2 rounded-md bg-slate-100 px-3 py-2 text-sm"
    >
      {/* Dot */}
      {mostRecentRelevantMaterialFact.category === "Fato Relevante" && (
        <div
          className="h-2 w-2"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: palette.mojo,
            borderRadius: 8,
          }}
        />
      )}
      {mostRecentRelevantMaterialFact.category === "Aviso aos Acionistas" &&
        mostRecentRelevantMaterialFact.type === "Outros avisos" && (
          <div
            className="h-2 w-2"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: palette.dixie,
              borderRadius: 8,
            }}
          />
        )}
      {mostRecentRelevantMaterialFact.category === "Dados Econômico-Financeiros" && (
        <div
          className="h-2 w-2"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: palette.scienceBlue,
            borderRadius: 8,
          }}
        />
      )}
      {mostRecentRelevantMaterialFact.category === "Comunicado ao Mercado" && (
        <div
          className="h-2 w-2"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: palette.amazon,
            borderRadius: 8,
          }}
        />
      )}

      <div>
        <strong className="flex font-bold text-gray-700 group-hover:text-blue-600">
          {mostRecentRelevantMaterialFact.category}
        </strong>

        <time
          suppressHydrationWarning={true}
          dateTime={deliveryDate.toISOString()}
          className="text-xs font-medium tracking-wide text-gray-500"
        >
          Último publicado—{lightFormat(deliveryDate, "dd/MM/yyyy")}
        </time>
      </div>

      <ArrowUpRight />
    </a>
  );
}
